import { makeAssetReducer } from './reducer-helpers';
import { SEARCH_ASSETS } from '../bridge-method-remap';
export default makeAssetReducer(SEARCH_ASSETS);
